<script setup lang="ts">
import {
  ExclamationTriangleIcon,
  HandThumbUpIcon,
} from '@heroicons/vue/24/outline';
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue';
import { usePopup } from '~/store/usePopup';

const popupStore = usePopup();
</script>

<template>
  <Dialog
    :open="popupStore.open"
    as="div"
    class="relative z-[1000]"
    @close="popupStore.open = false"
  >
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
    <div class="fixed inset-0 z-[1000] w-screen overflow-y-auto">
      <div
        class="flex min-h-full justify-center p-4 text-center items-center sm:p-0"
      >
        <DialogPanel
          class="sm:justify-between relative block sm:flex transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
        >
          <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <div
                :class="[
                  'mx-auto flex h-24 w-24 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-16 sm:w-16',
                  popupStore.modalError ? 'bg-red-100' : 'bg-green-100',
                ]"
              >
                <ExclamationTriangleIcon
                  v-if="popupStore.modalError"
                  class="h-12 w-12 text-red-600"
                  aria-hidden="true"
                />
                <HandThumbUpIcon
                  v-else
                  class="h-12 w-12 text-green-600"
                  aria-hidden="true"
                />
              </div>
              <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <DialogTitle
                  as="h3"
                  class="sm:mt-4 mt-0 text-2xl font-semibold leading-6 text-gray-900"
                >
                  {{ popupStore.modalText }}
                </DialogTitle>
              </div>
            </div>
          </div>
          <div
            class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse items-center sm:px-6"
          >
            <button
              type="button"
              class="h-10 mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              @click="popupStore.open = false"
              ref="cancelButtonRef"
            >
              Cancel
            </button>
          </div>
        </DialogPanel>
      </div>
    </div>
  </Dialog>
</template>
